import { render, staticRenderFns } from "./is-category.vue?vue&type=template&id=720be2cf&scoped=true"
import script from "./is-category.vue?vue&type=script&lang=js"
export * from "./is-category.vue?vue&type=script&lang=js"
import style0 from "./is-category.vue?vue&type=style&index=0&id=720be2cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720be2cf",
  null
  
)

export default component.exports